import { Helmet } from "react-helmet";
import "./foundryservices.scss"
import { Link } from "react-router-dom";

function Foundryservices() {

  const scrollToTop = () => {
    window.scrollTo(0, 0)
}
  return (
    <div className="metallurgicals">
      <Helmet>
        <title>Foundry Services || Raydron, Lagos, Nigeria</title>
        <meta name="description" content="We provide castings and custom casting services a wide range of industry sectors. We cast large valves, manhole covers, gully gratings, dead weights, etc."/>
        <meta name="keywords" content="manhole covers, gully gratings, valves, dead weights" />
      </Helmet>
        
        <div className="workflow__wrapper">
          <Link  to="/products/foundryservices/manholecover" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Manhole Covers</h2>
              <p className="text">We produce and supply light and heavy duty cast iron or ductile iron manhole covers for various applications. </p>
              
            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1740802782/manhole_1_eecghc.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>
          </Link>
          <Link  to="/products/foundryservices/gullygrating" style={{ textDecoration: 'none' }}>
          <div onClick={scrollToTop} className="workflow">
            <div className="explain">
              <h2 className="title">Gully Gratings</h2>
              <p className="text">We produce and supply various designs of gully gratings for drainage systems.</p>

            </div>
            <div className="photo__explain">
              <img src="https://res.cloudinary.com/dobxtcf1w/image/upload/v1740803999/gully_1_esaebe.jpg" alt="raydron_workflow" className="workflow__img" />
              <a href="https://wa.me/+2348066816640" target="_blank" rel="noreferrer" ><button className="btnWAPM">Chat Us to Buy</button></a>
            </div>
          </div>
          </Link>

        </div>
    </div>
  )
}

export default Foundryservices